import { Box, Checkbox, Stack, Typography } from '@lyearn/ui';
import UserDetail from '@/components/UsersSearch/components/UserDetail';
import useUsers from '@/components/UsersSearch/hooks/useUsers';
import { UserStatusEnum } from '@/types/schema';

const SelectedUsers = ({
  selectedUserIds,
  checkedUserIds,
  onClick,
}: {
  selectedUserIds: string[];
  checkedUserIds: string[];
  onClick: (userId: string) => void;
}) => {
  const { data: users } = useUsers({
    ids: selectedUserIds,
    pause: !selectedUserIds.length,
    status: [UserStatusEnum.Active, UserStatusEnum.Archived],
  });

  if (!users?.length) {
    return null;
  }

  return (
    <Stack direction="col">
      <Typography className="text-text-secondary pl-8" variant="label-caps">
        Selected
      </Typography>
      <Stack direction="col">
        {users?.map((user) => (
          <Box key={user.id} className="cursor-pointer" onClick={() => onClick(user.id)}>
            <UserDetail
              endAdornment={<Checkbox checked={checkedUserIds?.includes(user.id)} />}
              isArchived={user.status === UserStatusEnum.Archived}
              showEmail={false}
              user={user}
            />
          </Box>
        ))}
      </Stack>
    </Stack>
  );
};

export default SelectedUsers;
